import { Grid, GridItem } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { ControlProps, UISchemaElement } from "@jsonforms/core";
import { JsonFormsDispatch, withJsonFormsControlProps } from "@jsonforms/react";
import React from "react";

interface Row {
  elements: UISchemaElement[];
}

export function StatsTilesContainer(props: ControlProps) {
  const rows: Row[] = props.uischema.options?.rows;

  return (
    <div className={styles.container}>
      {rows.map((row, rowIndex) => {
        return (
          <Grid form={false} layout="report-tiles" key={rowIndex}>
            {row.elements?.map((element: UISchemaElement, index: number) => {
              const colSpan = element.options?.colSpan;
              return (
                <GridItem span={colSpan} key={index}>
                  <JsonFormsDispatch
                    schema={props.schema}
                    uischema={element}
                    path={`${props.path}`}
                  />
                </GridItem>
              );
            })}
          </Grid>
        );
      })}
    </div>
  );
}

const styles = {
  dataDisplayListCell: css({
    wordBreak: "break-word",
    fontSize: "var(--font-size-100)",
  }),
  container: css({
    gap: "var(--space-2)",
    display: "flex",
    flexDirection: "column",
  }),
};

export const StatsTilesContainerRenderer =
  withJsonFormsControlProps(StatsTilesContainer);
